export enum ConsultantBookingStatus {
  NeverBooked = "NeverBooked",
  BookedPreviously = "BookedPreviously",
  Booked = "Booked"
}
